import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters from '@atlassian/jira-relay/src/__generated__/StorageHardLimitsModalQuery.graphql';
import type { StorageHardLimitsModalEntryPointParams } from '@atlassian/jira-storage-hard-limits/src/ui/type.tsx';

export const attachmentDropzoneStorageHardLimitsModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "attachment-dropzone-storage-hard-limits-modal" */ './index'),
	),
	getPreloadProps: ({ cloudId, applicationKey }: StorageHardLimitsModalEntryPointParams) => ({
		queries: {
			StorageHardLimitsModalQuery: {
				parameters,
				variables: {
					cloudId,
					hamsProductKey: applicationKey,
				},
			},
		},
	}),
});
